import { render } from "./Wishlist.vue?vue&type=template&id=63263222&scoped=true"
import script from "../js/wishlist.js?vue&type=script&lang=js&external"
export * from "../js/wishlist.js?vue&type=script&lang=js&external"

import "./Wishlist.vue?vue&type=style&index=0&id=63263222&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63263222"]])

export default __exports__